import { RespondentCategory } from '.';

export const RESPONDENT_CATEGORY_ORDER = [
  RespondentCategory.OFFICER_DIRECTOR,
  RespondentCategory.DIRECTOR,
  RespondentCategory.EXECUTIVE_OFFICER,
  RespondentCategory.SHARE_HOLDER,
] as const;
